<template>
  <div class="flex flex-column gap-4">
    <div>
      <h3 class="m-0">Trainings</h3>
      <span class="profile-trainings-subtitle">Training progress and assigned modules</span>
    </div>

    <cna-renewal-hours-widget v-if="associateRoleName === 'cna'" :associate="associate" />

    <!-- <a-input-search
      v-model="searchValue"
      :style="{ width: '300px' }"
      placeholder="Search trainings..."
      size="large"
      @search="searchProp = searchValue"
    /> -->

    <a-spin :spinning="loading">
      <profile-company-flow :flow="filteredCompanyFlow" mode="trainings" @archive-sequence="archiveTraining" />
    </a-spin>
  </div>
</template>

<script>
import { Input, notification, Spin } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import ProfileCompanyFlow from './profile-company-flow.vue'
import CnaRenewalHoursWidget from '@/modules/sequence/components/cna-renewal-hours-widget.vue'

const { mapState: profileState, mapActions: profileActions } = createNamespacedHelpers('profile')
const { mapActions: sequenceActions } = createNamespacedHelpers('sequence')
const { mapActions: modalActions } = createNamespacedHelpers('modals')

export default {
  name: 'ProfileViewTrainings',
  components: {
    'a-input-search': Input.Search,
    'a-spin': Spin,
    'cna-renewal-hours-widget': CnaRenewalHoursWidget,
    'profile-company-flow': ProfileCompanyFlow
  },
  data() {
    return {
      loading: false,
      searchValue: undefined,
      searchProp: undefined
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate,
      associateCompanyFlow: state => state.associateCompanyFlow
    }),

    associateRoleName() {
      const role = this.associate?.role

      return String(role?.name).trim().toLowerCase()
    },

    filteredCompanyFlow() {
      if (!this.searchProp) {
        return this.associateCompanyFlow || {}
      }

      const searchTerm = this.searchProp.trim().toLowerCase()
      const trainings = this.associateCompanyFlow?.trainings

      return {
        ...(this.associateCompanyFlow || {}),
        trainings: {
          ...(trainings || {}),
          documents: (trainings?.documents || []).filter(item =>
            String(item.name || item.title || '')
              .toLowerCase()
              .includes(searchTerm)
          )
        }
      }
    }
  },
  watch: {
    'associate.id': {
      handler(newVal) {
        if (newVal) {
          this.loadCompanyFlow()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...profileActions(['getAssociateCompanyFlow']),
    ...sequenceActions(['archiveSequence']),
    ...modalActions(['openModal']),

    archiveTraining(training) {
      if (!training.signed_sequence_id) return

      this.openModal({
        type: 'deletion',
        data: {
          visible: true,
          title: 'Archive Training Record?',
          action: 'archive',
          description:
            'This archives this associate’s training record. A required training may return as Not started if no other record remains. The training configuration and other associates’ records stay unchanged.',
          onConfirm: async () => {
            await this.archiveSequence({ sequence_id: training.signed_sequence_id })
            this.showNotification('success', 'Success', 'Training record archived successfully.')
            await this.loadCompanyFlow()
          }
        }
      })
    },

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async loadCompanyFlow() {
      this.loading = true

      try {
        await this.getAssociateCompanyFlow({
          associate_id: this.associate.id
        })
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.profile-trainings-subtitle {
  color: var(--text-color-secondary);
}
</style>
